import { styled } from '@mui/material/styles';
import ToggleButton from '@mui/material/ToggleButton';
import { createUseStyles } from 'react-jss';
import { secondary } from 'helpers/colors';

export const CustomToggleButton = styled(ToggleButton)(() => ({
  height: 40,
  padding: '7px 10px',
  fontWeight: 500,
  '&.Mui-selected': {
    backgroundColor: secondary.main,
    color: secondary.contrast,
    '&:hover': {
      backgroundColor: secondary.hover
    }
  }
}));

const useStyle = createUseStyles({
  label: {
    fontSize: 13,
    paddingRight: 10
  }
});

export default useStyle;
